import React, { useContext, useState, useRef } from "react";
import noteContext from "../context/notes/noteContext";
const Addnote = (props) => {
  const {showAlert} = props
  const context = useContext(noteContext);
  const { addNote } = context;

  const [note, setNote] = useState({ title: "", description: "", tag: "" });

  const handleClick = (e) => {
    e.preventDefault();
    addNote(note.title, note.description, note.tag);
    setNote({ title: "", description: "", tag: "" });
    refClose.current.click();
    showAlert({type:"success", title:"Success:", message:"Note added to your collection."});
  };
  const refClose = useRef(null);

  const onChange = (e) => {
    setNote({ ...note, [e.target.name]: e.target.value });
  };
  return (
    <div className="container">
      <div
        className="modal fade"
        id="addNoteModal"
        tabIndex="-1"
        aria-labelledby="addNoteModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div
            className="modal-content"
            style={{ backgroundColor: "#f8f9fa", borderRadius: "20px" }}
          >
            <div className="modal-header">
              <h5 className="modal-title" id="addNoteModalLabel">
                Add New Note
              </h5>
            </div>

            <div className="modal-body">
              <form className="row g-3">
                <div className="col-md-6">
                  <label htmlFor="title" className="form-label">
                    Title
                  </label>
                  <input 
                    type="text"
                    className="form-control custom-text-input"
                    id="title"
                    name="title"
                    placeholder="enter note title...."
                    value={note.title}
                    onChange={onChange}
                    required
                    minLength={3}
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="tag" className="form-label">
                    Tag
                  </label>
                  <input
                    type="text"
                    className="form-control custom-text-input"
                    id="tag"
                    name="tag"
                    placeholder="tag the note...."
                    value={note.tag}
                    onChange={onChange}
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="description" className="form-label">
                    Description
                  </label>
                  <textarea
                    className="form-control custom-textarea"
                    id="description"
                    name="description"
                    placeholder="write your note here...."
                    value={note.description}
                    onChange={onChange}
                    rows="5"
                    required
                    minLength={5}
                  ></textarea>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                style={{
                  backgroundColor: "rgb(243, 244, 246)",
                  color: "#6b7280",
                  border: "none",
                  borderRadius: "8px",
                  padding: "8px 16px",
                  fontSize: "12px",
                  cursor: "pointer",
                  transition: "background-color 0.2s",
                }}
                onMouseOver={(e) => (e.target.style.backgroundColor = "#e5e7eb")}
                onMouseOut={(e) => (e.target.style.backgroundColor = "#f3f4f6")}
                ref={refClose}
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                style={{
                  backgroundColor: "#eab308",
                  color: "white",
                  textDecoration: "none",
                  padding: "7px 14px",
                  borderRadius: "8px",
                  fontSize: "12px",
                  fontWeight: "500",
                  transition: "background-color 0.2s",
                  border: "none", // removes visible border
                  outline: "none", // removes focus outline
                }}
                onClick={handleClick}
                onMouseOver={(e) => (e.target.style.backgroundColor = "#d97706")}
                onMouseOut={(e) => (e.target.style.backgroundColor = "#eab308")}
              >
                Save Note
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Addnote;
